(function () {
  function openPopup(overlay) {
    overlay.hidden = false;
    overlay.setAttribute('aria-hidden', 'false');

    // falls du später init brauchst:
    if (window.initEpxCalc) window.initEpxCalc(overlay);
  }

  function closePopup(overlay) {
    overlay.hidden = true;
    overlay.setAttribute('aria-hidden', 'true');
  }

  document.addEventListener('click', function (e) {
    const openBtn = e.target.closest('[data-epx-popup-open]');
    if (openBtn) {
      const overlay = openBtn.parentElement.querySelector('[data-epx-popup]');
      if (overlay) openPopup(overlay);
      return;
    }

    const closeBtn = e.target.closest('[data-epx-popup-close]');
    if (closeBtn) {
      const overlay = closeBtn.closest('[data-epx-popup]');
      if (overlay) closePopup(overlay);
      return;
    }

    const overlay = e.target.matches('[data-epx-popup]') ? e.target : null;
    if (overlay) closePopup(overlay);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    const overlay = document.querySelector('[data-epx-popup]:not([hidden])');
    if (overlay) closePopup(overlay);
  });
})();